import React from "react";
import { Box } from "@radix-ui/themes";
import { ConnectRivalsAccount } from "./ConnectRivalsAccount/ConnectRivalsAccount";

export const SettingsAccounts: React.FunctionComponent = () => {
  return (
    <Box>
      <ConnectRivalsAccount />
    </Box>
  );
};
